import script from "./TextAndVideoSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextAndVideoSection.vue?vue&type=script&setup=true&lang=ts"

import "./TextAndVideoSection.vue?vue&type=style&index=0&id=b3213514&lang=scss"

const __exports__ = script;

export default __exports__